import React, { useState } from 'react';
import { CompanyDashboardProps, fillColor } from '../constants';
import { CustomizedTickProps } from './types';

export const splitTextBySpace = (
  text: string,
  maxLineLength: number
): string[] => {
  const words = text.split(' ');
  const lines: string[] = [];
  let currentLine = '';

  for (const word of words) {
    const newLine = currentLine ? `${currentLine} ${word}` : word;

    if (newLine.length <= maxLineLength) {
      currentLine = newLine;
    } else {
      lines.push(currentLine);
      currentLine = word;
    }
  }
  if (currentLine) {
    lines.push(currentLine);
  }
  return lines;
};

export const CustomizedTick: React.FC<CustomizedTickProps> = props => {
  const { x, y, payload } = props;
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const displayValue =
    typeof payload.value === 'string'
      ? splitTextBySpace(payload.value, 17) // Adjust the max line length as needed
      : [payload.value.toString()];

  return (
    <g
      transform={`translate(${x},${y})`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      {displayValue.map((line, index) => (
        <text
          key={index}
          x={0}
          y={index * 11}
          dy={5}
          dx={-35}
          fontSize={11}
          transform={`rotate(-39)`}
          textAnchor={CompanyDashboardProps.MIDDLE}
          fill={fillColor}>
          {line.length > 12 ? `${line.substring(0, 12)}...` : line}
        </text>
      ))}
    </g>
  );
};
